// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
let ForSalePropertyAttributes__Lot = require("./ForSalePropertyAttributes__Lot.bs.js");
let ForSalePropertyAttributes__Condo = require("./ForSalePropertyAttributes__Condo.bs.js");
let ForSalePropertyAttributes__MultiUnit = require("./ForSalePropertyAttributes__MultiUnit.bs.js");
let ForSalePropertyAttributes__SingleFamily = require("./ForSalePropertyAttributes__SingleFamily.bs.js");
let ForSalePropertyAttributes_property_graphql = require("../../../__generated__/ForSalePropertyAttributes_property_graphql.bs.js");

let convertFragment = ForSalePropertyAttributes_property_graphql.Internal.convertFragment;

function ForSalePropertyAttributes$WithoutErrorBoundary(props) {
  let __displayPropertyType = props.displayPropertyType;
  let size = props.size;
  let displayPropertyType = __displayPropertyType !== undefined ? __displayPropertyType : true;
  let property = RescriptRelay_Fragment.useFragment(ForSalePropertyAttributes_property_graphql.node, convertFragment, props.property);
  let propertyType = property.propertyType;
  switch (propertyType.__typename) {
    case "CondoProperty" :
      return JsxRuntime.jsx(ForSalePropertyAttributes__Condo.make, {
        propertyType: propertyType.fragmentRefs,
        size: size,
        displayPropertyType: displayPropertyType
      });
    case "LotProperty" :
      return JsxRuntime.jsx(ForSalePropertyAttributes__Lot.make, {
        propertyType: propertyType.fragmentRefs,
        size: size,
        displayPropertyType: displayPropertyType
      });
    case "MultiUnitProperty" :
      return JsxRuntime.jsx(ForSalePropertyAttributes__MultiUnit.make, {
        propertyType: propertyType.fragmentRefs,
        size: size,
        displayPropertyType: displayPropertyType
      });
    case "SingleFamilyProperty" :
      return JsxRuntime.jsx(ForSalePropertyAttributes__SingleFamily.make, {
        propertyType: propertyType.fragmentRefs,
        size: size,
        displayPropertyType: displayPropertyType
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected property type: ` + propertyType._0);
  }
}

let WithoutErrorBoundary = {
  make: ForSalePropertyAttributes$WithoutErrorBoundary
};

function ForSalePropertyAttributes(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property attributes",
    children: JsxRuntime.jsx(ForSalePropertyAttributes$WithoutErrorBoundary, {
      property: props.property,
      size: props.size,
      displayPropertyType: props.displayPropertyType
    })
  });
}

let make = ForSalePropertyAttributes;

exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* react/jsx-runtime Not a pure module */
